import DesktopInfo from './DesktopInfo';

export default DesktopInfo;
